import { createBrowserHistory, createMemoryHistory } from 'history'
import { isSSR } from './isSSR'

export default isSSR ? createMemoryHistory({}) : createBrowserHistory({})
